import React from 'react';
import { ColorGroup } from '@meitu/xdesign-widgets';

interface IProps {
    title: string;
    color: string;
    onClick: (val: string) => void;
}
const Colors: React.FC<IProps> = (props) => {
    const { title, color, onClick } = props;

    return (
        <div className="design-svg-operate__color">
            <ColorGroup
                setColor={(color: string, transparent: boolean) => {
                    onClick?.(color);
                }}
                color={color}
            />
        </div>
    );
};
export default React.memo(Colors);
